import React from 'react';
import { Box, Typography } from '../primitives';
import { useTheme } from '@mui/material/styles';

/**
 * Composed FormSection component
 * Reusable form section wrapper
 */
const FormSection = ({ title, children, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mb: 3,
        ...props.sx,
      }}
      {...props}
    >
      {title && (
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
      )}
      <Box sx={{ mt: title ? 2 : 0 }}>
        {children}
      </Box>
    </Box>
  );
};

export default FormSection;

